<template>
  <div id="certificateTab">
    <v-card :loading="dataLoading">
      <v-card-title> Add Certificates </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <InfoBox
              title="Add Your Certificates Here. Certificates May Be used to verify your skills, so please have them readily available (either in digital or print format)"
            />
          </v-col>
          <v-col cols="12">
            <v-btn class="primary_btn w-100" prepend-icon="mdi-plus" @click="showAddOrEdit = true">Add Certificate</v-btn>
          </v-col>
        </v-row>
        <CertificateList
          :isHiringmanager="isHiringmanager"
          @remove="remove"
          @edit="edit"
          :skills="skills"
          :certificateList="items"
          :addLoading="addLoading"
        />
      </v-card-text>
      <v-dialog persistent v-model="showRemoveConfirm" @keydown.esc="showRemoveConfirm = false" max-width="400px">
        <confirm-dialog
          :loading="deleteLoading"
          @confirm="confirmDelete"
          @cancel="
            showRemoveConfirm = false;
            deleteLoading = false;
          "
          :message="confirmModel"
        >
        </confirm-dialog>
      </v-dialog>
      <v-dialog v-if="showAddOrEdit" v-model="showAddOrEdit" max-width="1000" @keydown.esc="cancel()" persistent>
        <CertificateRegister
          :isHiringmanager="isHiringmanager"
          :editingItem="editingItem"
          @cancel="cancel"
          :skills="skills"
          :isAfterSignUp="isAfterSignUp"
          :teammemberSkills="teammemberSkills"
          :addLoading="addLoading"
          @saved="saveCertificate"
          @scrollToElement="scrollToElement"
          :isGettingCertificate="isGettingCertificate"
        >
        </CertificateRegister>
      </v-dialog>
    </v-card>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import CertificateRegister from "./CertificateRegister.vue";
import CertificateList from "./CertificateList.vue";
import TeamMemberService from "../../../services/TeamMemberService";
import { Teammember, Certificate, TeammemberSkill } from "../../../models/Teammember";
import ConfirmDialog from "../../../components/ConfirmDialog.vue";
import { ProjectMessages } from "../../../definitions/constants";
import UploadService from "../../../services/UploadService";
import { AzureStorageUrl } from "../../../models/CourseModel";
import InfoBox from "../../InfoBox.vue";
import store from "@/store";

export default defineComponent({
  props: [
    "skills",
    "formLoading",
    "teammemberSkills",
    "isAfterSignUp",
    "isGettingAllSection",
    "certificates",
    "selectedTeammemberModel",
    "isHiringmanager",
  ],
  components: { CertificateRegister, ConfirmDialog, CertificateList, InfoBox },
  async mounted() {
    this.$emit("getCertificates");
  },
  data() {
    return {
      isGettingCertificate: false,
      teammemberSkillList: [] as TeammemberSkill[],
      technologies: [] as string[],
      selectedItem: {} as Certificate,
      editingItem: null as Certificate | null,
      itemRemoveId: -1,
      showRemoveConfirm: false,
      teammember: {} as Teammember | null,
      selectedId: null as string | null,
      dataLoading: false,
      loading: false,
      deleteLoading: false,
      addLoading: false,
      showDialog: false,
      items: [] as Certificate[],
      confirmModel: {
        title: ProjectMessages.removeCertificate,
        text: ProjectMessages.confirmation,
      },
      showAddOrEdit: false,
    };
  },
  watch: {
    formLoading(newVal) {
      this.dataLoading = newVal;
    },
    certificates(newVal) {
      this.items = newVal;
    },
    isGettingAllSection(newVal) {
      this.isGettingCertificate = newVal;
    },
  },
  methods: {
    scrollToElement(el: any) {
      this.$emit("scrollToElement", el);
    },
    cancel(): void {
      this.editingItem = null;
      this.showAddOrEdit = false;
    },
    certificateFileChanged(certificate: any) {
      this.$emit("certificateFileChanged", certificate);
    },
    remove(item: Certificate): void {
      this.selectedItem = item;
      this.showRemoveConfirm = true;
    },
    async confirmDelete() {
      this.deleteLoading = true;
      if (this.selectedItem) {
        var result = await TeamMemberService.deleteCertificate(
          this.selectedItem.Id,
          this.selectedTeammemberModel ? this.selectedTeammemberModel.id : ""
        );
        if (result) {
          this.editingItem = null;
          this.items = result;
          store.dispatch("showSuccessMessage", ProjectMessages.succesfullyDeleteCertificate);
        } else {
          store.dispatch("showErrorMessage", ProjectMessages.errorDeleteCertificate);
        }
      }
      this.showRemoveConfirm = false;
      this.deleteLoading = false;
    },
    edit(item: any): void {
      this.editingItem = item;
      this.showAddOrEdit = true;
    },
    async saveCertificate(event: { model: Certificate; callbackMethod: any; certificateFile: File }): Promise<void> {
      if (event.model) {
        this.addLoading = true;
        if (event.certificateFile != null) {
          var splitedFileName = event.certificateFile.name.split(".");
          event.model.UploadCertificateUrl = { Extension: splitedFileName[1] ?? "", FileName: splitedFileName[0] ?? "" } as AzureStorageUrl;
        }

        var result = await TeamMemberService.setCertificate(event.model, this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
        if (result && result.Id.length > 0) {
          if (event.certificateFile != null && result.UploadCertificateUrl != null) {
            await UploadService.uploadToContainer(event.certificateFile, result.UploadCertificateUrl.Url);
            result.CertificateFile = result.UploadCertificateUrl.FileName;
            result = await TeamMemberService.setCertificate(result, this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
          }

          if (this.editingItem == null) {
            this.items?.push(result);
          } else {
            var copyList = [...this.items];
            copyList[copyList.findIndex((item) => item.Id == this.editingItem?.Id)] = result;
            this.items = copyList;
          }
          this.$emit("fillCertificate", result);
          if (!this.isGettingCertificate) {
            if (event.model.Id) {
              store.dispatch("showSuccessMessage", ProjectMessages.succesfullyUpdateCertificate);
            } else {
              store.dispatch("showSuccessMessage", ProjectMessages.succesfullyAddCertificate);
            }
          }
          this.editingItem = null;
          event.callbackMethod();
        } else {
          store.dispatch("showErrorMessage", ProjectMessages.errorAddCertificate);
        }
        this.addLoading = false;
      } else {
        this.$emit("fillCertificate");
      }
    },
  },
});
</script>
